import React from 'react';
import { TextHighlighter } from '../utils/textHighlighter';

// Matches transaction totals: $9,009, $1.2B, $500 million, etc.
// Excludes per-share/per-unit prices via negative lookahead ([\d.]* prevents backtracking around decimals)
// Uses \d{1,3}(?:,\d{3})* to avoid capturing trailing punctuation commas
// [BMKT](?![a-zA-Z]) prevents matching "t" from words like "to"
const TRANSACTION_AMOUNT_REGEX = /\$\d{1,3}(?:,\d{3})*(?:\.\d+)?(?:\s?(?:billion|million|trillion|thousand|[BMKT](?![a-zA-Z])))?(?![\d.]*\s*(?:per\s+(?:share|unit)|each|apiece|a\s+share))/;

const AiSummaryBox = ({ aiSummary }) => {
    if (!aiSummary) return null;
    return (
        <div className="body-s-semibold color-text-secondary">
            <span className="body-s-bold">AI Summary: </span>
            <TextHighlighter
                contentString={aiSummary}
                regexPatterns={[{ pattern: TRANSACTION_AMOUNT_REGEX, highlightClassName: 'body-m-bold' }]}
                typography={{ className: '' }}
                isInline={true}
            />
        </div>
    );
};

export default AiSummaryBox;
